import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItemModel } from 'src/app/core/models/analytics/menu-item-model';
import { AnalyticsService } from 'src/app/core/services/analytics/analytics.service';
import { GDPRService } from 'src/app/core/services/rulebook';

@Component({
  selector: 'app-self-assessment-template3',
  templateUrl: './self-assessment-template3.component.html',
  styleUrls: ['./self-assessment-template3.component.scss'],
})
export class SelfAssessmentTemplate3Component implements OnInit {
  isActive = false;
  libraryMenu: Array<MenuItemModel> = [];
  constructor(
    private analyticsService: AnalyticsService,
    public gdprService: GDPRService,
    private router: Router
  ) {
    this.gdprService.tabActive =
      this.router.url.indexOf('/self-assessment/details/') >= 0 ? true : false;
  }
  ngOnInit() {
    this.getUserMenu();
  }
  getUserMenu(): void {
    this.analyticsService
      .getLibraryMenu()
      .subscribe((data: MenuItemModel[]) => {
        this.libraryMenu = data;
      });
  }
  getTabText(url: string): void {
    this.gdprService.tabActive = url === 'Details' ? true : false;
  }
  checkRoutePermission(currentUrl: string): boolean {
    return this.libraryMenu.find(
      (a) => a.screenUrl === currentUrl && a.parentId != null
    )
      ? true
      : false;
  }
}
